import { CellProps, Box, ErrorOutline, Flex, Text } from "@shared/primitive-components"
import { AddedFleetEntry } from "../../../../../../api/fleet"
import * as styles from "./styles"

export const EntryPropertyCell = ({ value }: CellProps<string | undefined, AddedFleetEntry>) => {
  if (!value)
    return (
      <Flex alignItems="center">
        <Text tag="span">Unknown</Text>
        <Box as="span" css={styles.unknownPropertyIcon}>
          {ErrorOutline}
        </Box>
      </Flex>
    )
  return <>{value}</>
}
